import React, { useEffect } from "react";
import img from "../images/business-opportunity.webp";
import logo from "../image/FooterLogo.png";

export default function NewOpportunity() {
  return (
    <section className="section">
      <headerdm className="main-header">
        <div className="container-html">
          <div className="row align-items-center">
            <div className="col-lg-1 col-md-1 col-3">
              <div className="logohtml">
                <a href="/">
                  <img
                    className="img-fluiddm"
                    src={require("../image/NavLogo.png")}
                    alt="iRobot"
                    height="50"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </headerdm>
      <div className="opportunity-container" dir="rtl">
        <div className="image-container">
          <img
            src={img}
            alt="Example"
            className="content-image2"
          />
        </div>
        <div className="opportunity-content">
          <p>הודו נחשבת לשוק מורכב במיוחד לחדירה של מוצרים זרים לצרכני קצה מקומיים והדרישות המקדמיות לרוב מקשות על כניסה של חברות קטנות ובינוניות.</p><br/>
          <p>פיורסייט, המנוהלת על ידי אנשי עסקים ישראלים מנוסים, פיתחה פלטפורמה המיועדת לסיוע במכירה קמעונאית בהודו.</p><br/>
          <p>פיורסייט מציעה לחברות ישראליות שימוש בפלטפורמה באמצעותה שיווקה ומכרה בהצלחה במשך שנים רבות את מוצרי iRobot בהודו. הפלטפורמה מיועדת לחברות אשר מעוניינות למכור מוצרים לצרכני קצה בהודו.</p><br/>
          <p>הלקוחות יכולים להיות ממגוון תחומים המיועדים לצרכני קצה, כגון: מוצרי אלקטרוניקה, מוצרי וכלי בית, חצר ופנאי, קוסמטיקה ולייפסטייל ועוד.</p><br/>
          <p>הפעילות כוללת:</p><br/>
          <ul>
            <li>שירותי ייעוץ ותפעול יבוא (החברה בעלת רישיונות יבוא/יצוא)</li><br/>
            <li>שירותי ייעוץ ושיווק מקומי (לרבות שיווק דיגיטלי)</li><br/>
            <li>שירותי אחסנה ושטחי אחסון בהודו</li><br/>
            <li>שירותים פיננסיים עבור פעילות המכירות</li><br/>
            <li>אפשרות לאולם תצוגה בבנגלור, כולל צוות</li><br/>
            <li>אפשרות למרכז שירות מקומי, כולל צוות טכני</li><br/>
          </ul>
          <ul>
            <li>רישום באמזון הודו ובפלטפורמות איקומרס מקומיות אחרות, המאפשר פרסום ומכירה ישירה ללקוחות קצה (ראוי להדגיש שחברה זרה אינה יכולה בד"כ למכור בהודו באופן ישיר ללא הקמת חברה ואופרציה מקומית)</li><br/>
            <li>צוות עובדים מקומי בניהול ישראלי</li><br/>
            <li>מגוון שירותים מקומיים אחרים, לפי הנדרש</li><br/>
          </ul>
          <p>לפרטים נוספים: <a href="mailto:sharonz@puresight.co.in" className="text-black hover:underline">sharonz@puresight.co.in</a></p>
        </div>
      </div>
      <footer className=" custom-footer">
        <div className="">
          <div className="opportunity-footer-logo">
            <a href="/">
              <img src={logo} alt="iRobot Footer Logo" />
            </a>
          </div>
        </div>
      </footer>
    </section>
  );
}